import { getAccessToken } from 'api/accessToken';
import { QueryKeys } from 'api/queryKeys';
import axios from 'axios';
import { useQueryWithCallbacks } from 'hooks/useQueryWithCallbacks';
import { enqueueSnackbar } from 'notistack';

// The branches list is served by the asset server at the app origin (`/dev/branches`),
// NOT the API (`/api/dev/branches`), so we use a bare axios instance instead of the
// api interceptor which prepends the `/api` base URL.
const assetServerClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

interface IBranch {
  key: string;
}

interface IUseGetBranchesOptions {
  enabled?: boolean;
  onSuccess?: (branches: string[]) => void;
}

export const useGetBranches = ({ enabled = true, onSuccess }: IUseGetBranchesOptions = {}) => {
  return useQueryWithCallbacks<string[], Error>({
    queryKey: [QueryKeys.developerGetBranches],
    queryFn: async () => {
      // Reuse the API interceptor's cached token so we don't hit Auth0 every request.
      const token = await getAccessToken();
      const { data } = await assetServerClient.get<IBranch[]>('/dev/branches', {
        headers: token ? { 'x-bearer-token': token } : undefined,
      });
      return data.map(branch => branch.key);
    },
    enabled,
    refetchOnWindowFocus: false,
    onSuccess,
    onError: error => {
      enqueueSnackbar(error.message || 'Failed to load branches', { variant: 'error' });
    },
  });
};
